import * as React from 'react'
import Image from 'next/image'

import styles from './Category.module.css'

type CategoryProps = {
  loading: boolean
  label: string
  imageUrl?: string
  color?: string
}

const Category: React.FC<CategoryProps> = ({
  loading,
  label,
  imageUrl,
  color,
}) => {
  if (loading) return null
  return (
    <div
      className={styles.categoryContainer}
      style={{ backgroundColor: !imageUrl && !loading && color }}
    >
      {imageUrl && (
        <div className={styles.imageContainer}>
          <Image
            className={styles.image}
            src={imageUrl}
            alt={label}
            layout="fill"
          />
        </div>
      )}
      <span className={styles.label}>{label}</span>
    </div>
  )
}

export default Category
